module.exports = __webpack_public_path__ + "MagnifyingGlass___3UCal.svg";